/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitDtoModel, VisitDtoModelType } from "./VisitDtoModel"
import { VisitDtoModelSelector } from "./VisitDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  visit: VisitDtoModelType;
}

/**
 * RouteTimelineEventDtoBase
 * auto generated base class for the model RouteTimelineEventDtoModel.
 */
export const RouteTimelineEventDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteTimelineEventDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineEventDto"), "RouteTimelineEventDto"),
    id: types.union(types.undefined, types.integer),
    routeTimelineId: types.union(types.undefined, types.integer),
    visitId: types.union(types.undefined, types.null, types.integer),
    visit: types.union(types.undefined, MSTGQLRef(types.late((): any => VisitDtoModel))),
    eventType: types.union(types.undefined, types.string),
    originalArrivalTime: types.union(types.undefined, types.string),
    expectedArrivalTime: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteTimelineEventDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeTimelineId() { return this.__attr(`routeTimelineId`) }
  get visitId() { return this.__attr(`visitId`) }
  get eventType() { return this.__attr(`eventType`) }
  get originalArrivalTime() { return this.__attr(`originalArrivalTime`) }
  get expectedArrivalTime() { return this.__attr(`expectedArrivalTime`) }
  visit(builder: string | VisitDtoModelSelector | ((selector: VisitDtoModelSelector) => VisitDtoModelSelector) | undefined) { return this.__child(`visit`, VisitDtoModelSelector, builder) }
}
export function selectFromRouteTimelineEventDto() {
  return new RouteTimelineEventDtoModelSelector()
}

export const routeTimelineEventDtoModelPrimitives = selectFromRouteTimelineEventDto().routeTimelineId.visitId.eventType.originalArrivalTime.expectedArrivalTime
